"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @internalapi */
exports.resolvePolicies = {
    when: {
        LAZY: "LAZY",
        EAGER: "EAGER"
    },
    async: {
        WAIT: "WAIT",
        NOWAIT: "NOWAIT",
        RXWAIT: "RXWAIT"
    }
};
//# sourceMappingURL=interface.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@uirouter/core/lib/resolve/interface.js
// module id = 145
// module chunks = 0